// Main Web Audio API module, takes care of creating and resuming
// Audio context, maintaining sources and providing some effects.

import * as buffers from './audio/buffers.js';
import * as panner from './audio/panner.js';

// References
let ac;
const sources = [];

function init() {
    // Create AudioContext
    ac = new AudioContext();
    if (DEVMODE) console.log('Audio context sample rate: ' + ac.sampleRate);
}

function resume() {
    // Resume context, dealing with autoplay policy
    if (ac.state === 'suspended') {
        if (DEVMODE) console.log('Resuming AudioContext');
        return ac.resume();
    } else {
        return Promise.resolve();
    }
}

// Fade to an absolute level in db
// Default to a fade in behavior from -90db
// this function is used as a source method 
function fadeTo(time = 2, level = 0, fromLevel = -90, mode = 'linear') {
    this.gainNode.gain.setValueAtTime(dbToGain(fromLevel), ac.currentTime);
    if (mode === 'linear') {
        this.gainNode.gain.linearRampToValueAtTime(dbToGain(level), ac.currentTime + time);
    } else {
        this.gainNode.gain.exponentialRampToValueAtTime(dbToGain(level), ac.currentTime + time);
    }
    return this;
}

// Fade to a new level by applying a relative db gain
// Defaults to a fade out behavior
// this function is used as a source method 
function fade(time = 2, db = -90, andStop = false, mode = 'linear') {
    const currentGain = this.gainNode.gain.value;
    // This setValueAtTime call below is required for Firefox and Safari.
    // Otherwise, linearRampToValueAtTime will do nothing until
    // ac.currentTime + time is reached and then immeditaley drop to -90db.
    // Is this a bug?
    this.gainNode.gain.setValueAtTime(currentGain, ac.currentTime);
    if (mode === 'linear') {
        this.gainNode.gain.linearRampToValueAtTime(currentGain * dbToGain(db), ac.currentTime + time);
    } else {
        this.gainNode.gain.exponentialRampToValueAtTime(currentGain * dbToGain(db), ac.currentTime + time);
    }
    if (andStop) this.stop(ac.currentTime + time);
    return this;
}

function fadeOutAll(time = 2, finalGain = -90) {
    // Fade out all sources and stop them
    sources.forEach(s => s.fade(time, finalGain, true));
}

function stopAll() {
    sources.forEach(s => s.stop());
}

function forget(source) {
    const index = sources.indexOf(source);
    sources.splice(index, 1);
}

function gainToDB(gain) {
    return 20 * log10(gain)

    function log10(x) {
        return Math.log(x)/Math.LN10;
    }
}

function dbToGain(db) {
    return Math.pow(10, db / 20);
}

export {
    ac as context, sources,
    init, resume,
    fadeTo, fade, fadeOutAll, stopAll,
    forget,
    buffers, panner,
    gainToDB, dbToGain,
};
